<script>
    import { onMount } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Btm from "../components/Btm.svelte";
    import * as common from "../utiles/common.util";
    import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";

    export let params;
    let as_id = params.as_id;
    let asData = null; // AS 상세 데이터 저장
    let files = [];
    let previews = [];
    let symptom = "";
    let loading = false;
    let initialLoading = true;
    let selectedImageIndex = null;
    let isInfoOpen = false;

    onMount(async () => {
        previews = [];
        files = [];
        await getAsDetail();
    });

    async function getAsDetail() {
        try {
            const response = await api.get(`/assignment/${as_id}`);
            if (response && response.data) {
                asData = response.data; // 명확한 할당으로 반응성 보장
            }
        } catch (error) {
            console.error("Failed to fetch AS detail:", error);
        } finally {
            initialLoading = false;
        }
    }

    async function putData() {
        if (loading) return;

        if (!symptom.trim()) {
            alert("증상을 입력해주세요.");
            return;
        }

        loading = true;
        try {
            const formData = new FormData();
            formData.append("as_id", as_id);
            formData.append("symptom", symptom);
            // files 배열에 있는 유효한 파일들만 추가 (기존 전송 방식 유지)
            files.forEach((file) => {
                if (file) formData.append("fileList_startAS", file);
            });

            const response = await api.post(`/process/put`, formData);

            if (response != null) {
                alert(response.msg || "등록되었습니다.");
                push("/AsList");
            }
        } catch (error) {
            console.error("Error submitting AS form:", error);
            alert("등록 중 오류가 발생했습니다.");
        } finally {
            loading = false;
        }
    }

    function handleFiles(event) {
        const newFiles = Array.from(event.target.files);
        if (newFiles.length === 0) return;

        newFiles.forEach((file) => {
            const previewUrl = URL.createObjectURL(file);
            // 개수 제한 없이 배열에 추가
            previews = [...previews, previewUrl];
            files = [...files, file];
        });

        event.target.value = "";
    }

    function deleteOne(index) {
        if (previews[index]) {
            URL.revokeObjectURL(previews[index]);
        }

        files = files.filter((_, i) => i !== index);
        previews = previews.filter((_, i) => i !== index);
    }

    function clearAll() {
        previews.forEach((src) => src && URL.revokeObjectURL(src));
        files = [];
        previews = [];
    }

    function openModal(index) {
        selectedImageIndex = index;
    }

    function closeModal() {
        selectedImageIndex = null;
    }

    function nextImage(e) {
        e.stopPropagation();
        if (selectedImageIndex < previews.length - 1) {
            selectedImageIndex += 1;
        } else {
            selectedImageIndex = 0; // 처음으로 순환
        }
    }

    function prevImage(e) {
        e.stopPropagation();
        if (selectedImageIndex > 0) {
            selectedImageIndex -= 1;
        } else {
            selectedImageIndex = previews.length - 1; // 마지막으로 순환
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-missing-attribute -->
<div class="as-wrapper custom-theme main-body">
    <div class="as-main">
        <header class="as-header">
            <div class="header-content">
                <button class="back-btn" on:click={() => window.history.back()}>
                    <svg
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                    >
                        <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                </button>
                <h2>작업 시작 등록</h2>
            </div>
        </header>

        <main class="as-form-container scroll-custom">
            {#if initialLoading}
                <div class="state-container">
                    <div class="loader"></div>
                    <p>정보를 불러오고 있습니다...</p>
                </div>
            {:else if asData}
                <!-- 접수 정보 요약 카드 -->
                <section class="info-summary-card">
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <!-- svelte-ignore a11y-no-static-element-interactions -->
                    <div
                        class="summary-header"
                        on:click={() => (isInfoOpen = !isInfoOpen)}
                        style="cursor: pointer;"
                    >
                        <div
                            style="display: flex; align-items: center; gap: 8px;"
                        >
                            <span class="summary-badge">접수 정보</span>
                            <span class="summary-time">
                                {asData?.created_at || ""}
                            </span>
                        </div>
                        <button class="toggle-btn" aria-label="Toggle Info">
                            {#if isInfoOpen}
                                <svg
                                    viewBox="0 0 24 24"
                                    width="20"
                                    height="20"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    fill="none"
                                >
                                    <polyline
                                        points="18 15 12 9 6 15"
                                    ></polyline>
                                </svg>
                            {:else}
                                <svg
                                    viewBox="0 0 24 24"
                                    width="20"
                                    height="20"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    fill="none"
                                >
                                    <polyline
                                        points="6 9 12 15 18 9"
                                    ></polyline>
                                </svg>
                            {/if}
                        </button>
                    </div>
                    {#if isInfoOpen}
                        <div class="summary-body">
                            <div class="summary-main">
                                <h3 class="summary-item-name">
                                    {asData?.item_name || "제품 정보 없음"}
                                </h3>
                            </div>
                            <div class="summary-grid">
                                <div class="summary-row">
                                    <span class="label">접수처</span>
                                    <span class="value">
                                        {asData?.cus_name || "-"}
                                    </span>
                                </div>
                                <div class="summary-row">
                                    <span class="label">수리처</span>
                                    <span class="value">
                                        {asData?.cus_name_rpr || "-"}
                                    </span>
                                </div>
                            </div>
                            <div class="summary-row address-row">
                                <span class="label">주소</span>
                                <span class="value">
                                    {asData?.addr1 || ""}
                                    {asData?.addr2 || ""}
                                </span>
                            </div>
                            {#if asData?.symptom_cus}
                                <div class="summary-row symptom-row-sm">
                                    <span class="label">기존 접수 증상</span>
                                    <div
                                        class="value-symptom scroll-custom-symptom"
                                    >
                                        {asData.symptom_cus.replaceAll(
                                            "\r\n",
                                            "\n",
                                        )}
                                    </div>
                                </div>
                            {/if}
                        </div>
                    {/if}
                </section>

                <section class="form-section">
                    <div class="section-title">작업 전 증상</div>
                    <textarea
                        bind:value={symptom}
                        placeholder="현장에서 확인한 증상을 상세히 입력해주세요."
                        class="symptom-textarea"
                        disabled={loading}
                    ></textarea>
                </section>

                <section class="form-section">
                    <div class="section-header">
                        <div class="section-title">
                            작업 전 사진 ({previews.length}장)
                        </div>
                        <div class="file-actions">
                            <input
                                type="file"
                                id="input-file"
                                class="hidden-input"
                                accept="image/*"
                                multiple
                                on:change={handleFiles}
                                disabled={loading}
                            />
                            <label class="add-file-btn" for="input-file">
                                사진 추가 +
                            </label>
                        </div>
                    </div>

                    <div class="image-grid">
                        {#each previews as src, index}
                            <div
                                class="image-slot"
                                on:click={() => openModal(index)}
                            >
                                <img {src} alt="preview" class="preview-img" />
                                <button
                                    class="delete-btn"
                                    on:click|stopPropagation={() =>
                                        deleteOne(index)}
                                    disabled={loading}
                                >
                                    <span class="delete-icon">✕</span>
                                </button>
                            </div>
                        {/each}
                        {#if previews.length === 0}
                            <div class="no-images">
                                <img src="../img/img_none.png" alt="none" />
                                <p>등록된 사진이 없습니다.</p>
                            </div>
                        {/if}
                    </div>
                </section>
            {:else}
                <div class="state-container">
                    <p>데이터를 찾을 수 없습니다.</p>
                </div>
            {/if}
        </main>

        {#if selectedImageIndex !== null}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div class="image-modal" on:click={closeModal}>
                <div class="modal-content" on:click|stopPropagation>
                    <img
                        src={previews[selectedImageIndex]}
                        alt="full-size"
                        class="full-img"
                    />

                    {#if previews.length > 1}
                        <button class="nav-btn prev" on:click={prevImage}>
                            <svg
                                viewBox="0 0 24 24"
                                width="32"
                                height="32"
                                stroke="white"
                                stroke-width="2"
                                fill="none"
                            >
                                <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                        </button>
                        <button class="nav-btn next" on:click={nextImage}>
                            <svg
                                viewBox="0 0 24 24"
                                width="32"
                                height="32"
                                stroke="white"
                                stroke-width="2"
                                fill="none"
                            >
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </button>
                        <div class="img-counter">
                            {selectedImageIndex + 1} / {previews.length}
                        </div>
                    {/if}

                    <button class="close-modal-btn" on:click={closeModal}>
                        ✕ 닫기
                    </button>
                </div>
            </div>
        {/if}

        <footer class="form-footer">
            <button
                class="footer-btn btn-clear"
                on:click={clearAll}
                disabled={loading || files.filter((f) => f).length === 0}
            >
                초기화
            </button>
            <button
                class="footer-btn btn-submit"
                on:click={putData}
                disabled={loading}
            >
                {#if loading}
                    등록 중...
                {:else}
                    작업 시작 등록
                {/if}
            </button>
        </footer>

        <div class="btm-wrap">
            <Btm />
        </div>
    </div>
</div>

<style>
    .as-wrapper {
        height: 100vh;
        height: 100dvh;
        overflow: hidden;
        background-color: var(--bg-color);
    }

    .as-main {
        display: flex;
        flex-direction: column;
        max-width: 1024px;
        margin: 0 auto;
        height: 100vh;
        height: 100dvh;
        position: relative;
        overflow: hidden; /* 내부 스크롤을 위해 고정 */
    }

    .as-header {
        background-color: var(--card-bg);
        padding: 16px 20px;
        border-bottom: 1px solid var(--border-color);
        box-shadow: var(--shadow-sm);
        z-index: 10;
    }

    .header-content {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .back-btn {
        background: none;
        border: none;
        padding: 8px;
        cursor: pointer;
        font-size: 1.2rem;
    }

    .as-header h2 {
        font-size: 1.3rem;
        font-weight: 800;
        color: var(--text-color);
        margin: 0;
    }

    .as-form-container {
        flex: 1;
        overflow-y: auto;
        padding: 20px 20px 180px; /* 푸터 여백 확보 */
        display: flex;
        flex-direction: column;
        gap: 24px;
        -webkit-overflow-scrolling: touch; /* iOS 스크롤 부드럽게 */
    }

    /* 정보 요약 카드 스타일 */
    .info-summary-card {
        background-color: var(--card-bg);
        border-radius: 20px;
        border: 1px solid var(--border-color);
        box-shadow: var(--shadow-sm);
        overflow: hidden;
        margin-bottom: 24px;
        flex-shrink: 0; /* 부모 flex에 의해 찌그러지지 않도록 고정 */
        display: block; /* 블록 요소로 명시 */
        height: auto; /* 내용에 맞게 늘어남 */
        min-height: fit-content;
    }

    .summary-header {
        padding: 10px 16px;
        background-color: var(--input-bg);
        border-bottom: 1px solid var(--border-color);
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .summary-badge {
        font-size: 0.75rem;
        font-weight: 800;
        color: var(--primary-color);
        background-color: rgba(59, 130, 246, 0.1);
        padding: 2px 8px;
        border-radius: 4px;
    }

    .summary-time {
        font-size: 0.8rem;
        color: var(--text-color);
        opacity: 0.5;
        font-weight: 600;
    }

    .toggle-btn {
        background: none;
        border: none;
        color: var(--text-color);
        opacity: 0.6;
        cursor: pointer;
        padding: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .summary-body {
        padding: 16px 20px;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .summary-item-name {
        font-size: 1.2rem;
        font-weight: 900;
        color: var(--text-color);
        margin: 0;
    }

    .summary-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
        border-top: 1px dashed var(--border-color);
        padding-top: 12px;
    }

    .summary-row {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .summary-row .label {
        font-size: 0.75rem;
        font-weight: 600;
        color: var(--text-color);
        opacity: 0.4;
    }

    .summary-row .value {
        font-size: 0.95rem;
        font-weight: 700;
        color: var(--text-color);
    }

    .address-row {
        border-top: 1px dashed var(--border-color);
        padding-top: 12px;
    }

    .symptom-row-sm {
        margin-top: 4px;
        padding: 10px;
        background-color: var(--input-bg);
        border-radius: 8px;
    }

    .value-symptom {
        font-size: 1rem;
        color: var(--text-color);
        opacity: 0.7;
        white-space: pre-wrap;
        line-height: 1.4;
    }

    .scroll-custom-symptom {
        max-height: 5.6rem; /* 1.0rem * 1.4 (line-height) * 4 lines */
        overflow-y: auto;
        /* common.css에 정의된 scroll-custom 스타일을 활용 */
        -webkit-overflow-scrolling: touch;
    }

    .form-section {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .section-title {
        font-size: 1.1rem;
        font-weight: 800;
        color: var(--text-color);
    }

    .symptom-textarea {
        width: 100%;
        min-height: 180px;
        padding: 16px;
        border-radius: 12px;
        background-color: var(--card-bg);
        border: 1px solid var(--input-border);
        color: var(--text-color);
        font-size: 1.1rem;
        line-height: 1.6;
        resize: none;
    }

    .symptom-textarea:focus {
        border-color: var(--primary-color);
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
    }

    .hidden-input {
        display: none;
    }

    .add-file-btn {
        background-color: var(--input-bg);
        color: var(--text-color);
        padding: 8px 16px;
        border-radius: 8px;
        font-size: 0.95rem;
        font-weight: 700;
        border: 1px solid var(--border-color);
        cursor: pointer;
    }

    .image-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
    }

    .image-slot {
        aspect-ratio: 1;
        background-color: var(--card-bg); /* 배경을 카드 배경색으로 변경 */
        border-radius: 12px;
        overflow: hidden;
        position: relative;
        border: 2px solid var(--border-color); /* 테두리를 조금 더 두껍게 */
        box-shadow: var(--shadow-sm); /* 은은한 그림자 추가 */
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .image-slot:hover {
        border-color: var(--primary-color);
    }

    .no-images {
        grid-column: span 3;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px;
        background-color: var(--input-bg);
        border-radius: 16px;
        border: 2px dashed var(--input-border); /* 대시 테두리를 더 명확하게 */
        opacity: 0.8; /* 투명도를 높여서 더 잘 보이게 함 */
    }

    .no-images img {
        width: 48px;
        margin-bottom: 12px;
    }

    /* 이미지 확대 모달 */
    .image-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        height: 100dvh; /* 브라우저 하단 바를 고려한 동적 높이 */
        background-color: rgba(0, 0, 0, 0.95);
        z-index: 2000;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
    }

    .modal-content {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: env(
            safe-area-inset-bottom
        ); /* 시스템 하단 바 영역 보호 */
    }

    .full-img {
        max-width: 85%; /* 좌우 버튼 영역을 확보하기 위해 폭 제한 */
        max-height: 70dvh;
        object-fit: contain;
        border-radius: 8px;
        transition: opacity 0.2s ease;
    }

    .nav-btn {
        position: absolute;
        top: 45%;
        transform: translateY(-50%);
        background: none; /* 배경 제거 */
        border: none;
        padding: 20px 15px;
        cursor: pointer;
        display: flex;
        align-items: center;
        z-index: 10;
        filter: drop-shadow(
            0 0 5px rgba(0, 0, 0, 0.8)
        ); /* 아이콘 가독성 확보 */
    }

    .nav-btn:active {
        transform: translateY(-50%) scale(0.9);
    }

    .nav-btn.prev {
        left: 10px;
    }
    .nav-btn.next {
        right: 10px;
    }

    .img-counter {
        position: absolute;
        top: calc(20px + env(safe-area-inset-top)); /* 상단 노치 영역 고려 */
        color: white;
        font-size: 1.1rem;
        font-weight: 700;
        background: rgba(0, 0, 0, 0.5);
        padding: 5px 15px;
        border-radius: 20px;
    }

    .close-modal-btn {
        position: absolute;
        bottom: calc(
            30px + env(safe-area-inset-bottom)
        ); /* 하단 네비바가 있으면 그 위에, 없으면 적절한 위치에 고정 */
        background-color: var(--primary-color);
        color: white;
        border: none;
        padding: 14px 40px;
        border-radius: 100px;
        font-size: 1.1rem;
        font-weight: 800;
        cursor: pointer;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
    }

    .preview-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .delete-btn {
        position: absolute;
        top: 6px;
        right: 6px;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.6);
        color: white;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 2; /* z-index를 낮게 설정하여 하단 푸터나 모달에 가려지도록 함 */
    }

    .form-footer {
        position: absolute;
        bottom: 70px; /* Btm 위 */
        left: 0;
        right: 0;
        padding: 16px 20px;
        background-color: var(--bg-color);
        display: flex;
        gap: 12px;
        border-top: 1px solid var(--border-color);
        z-index: 50; /* 이미지 슬롯보다 높게 설정 */
    }

    .footer-btn {
        flex: 1;
        padding: 16px;
        font-size: 1.15rem;
        font-weight: 800;
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.2s;
        border: none;
    }

    .btn-clear {
        flex: 0.4;
        background-color: var(--input-bg);
        color: var(--text-color);
        border: 1px solid var(--border-color);
    }

    .btn-submit {
        background-color: var(--primary-color);
        color: white;
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
    }

    .btm-wrap {
        flex-shrink: 0;
        height: 70px;
        position: relative;
    }

    /* 로딩 상태 */
    button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .state-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 60vh;
        color: var(--text-color);
        opacity: 0.5;
    }

    .loader {
        border: 4px solid var(--border-color);
        border-top: 4px solid var(--primary-color);
        border-radius: 50%;
        width: 40px;
        height: 40px;
        animation: spin 1s linear infinite;
        margin-bottom: 16px;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
